import { useGetClientByIdQuery } from '@entities/clients/rtk-query.ts';
import { useParams } from 'react-router-dom';
import { useClientMobilePageRedirect } from '@pages/clients/client-page/useClientMobilePageRedirect.ts';
import { ClientMenu } from '@features/clients/index.ts';
import { PageBackButton } from '@features/common/PageBackButton/index.tsx';
import { ListBody, PageHead, PageTitle } from '@shared/ui';
import { Loader } from '@src/library/components/common/index.ts';
import { ClientMobile } from '@src/widgets/clients';
import * as st from './styles.module.scss';

export const ClientPage: React.FC = () => {
  const { clientId } = useParams();
  const { data: client, isLoading } = useGetClientByIdQuery(Number(clientId));
  const { doRedirectOnPrevPage } = useClientMobilePageRedirect();
  const isClientNotExist = isLoading || !client;
  return (
    <>
      <PageTitle title="Клиент" />
      <PageHead
        Left={<PageBackButton onClick={() => doRedirectOnPrevPage('/clients/clients')} />}
        Right={isClientNotExist ? undefined : <ClientMenu client={client} />}
      />
      <ListBody>
        {isClientNotExist ? (
          <Loader />
        ) : (
          <div className={st.clients}>
            <ClientMobile client={client} />
          </div>
        )}
      </ListBody>
    </>
  );
};
